function LoaderMw (request, next) {
  this.$wait.start()
  document.body.style.cursor = 'wait'

  next(function (response) {
    this.$wait.end()
    document.body.style.cursor = 'default'
  })
}

export default LoaderMw
